/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Desabilita permanentemente o link da logo
(function () {

    function disableLogoLink() {
        document.querySelectorAll('.Header__LogoLink').forEach(link => {

            link.removeAttribute('href');

            link.onclick = function (e) {
                e.preventDefault();
                return false;
            };

        });
    }

    document.addEventListener('DOMContentLoaded', disableLogoLink);

    const observer = new MutationObserver(disableLogoLink);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();